// extracted by mini-css-extract-plugin
export var checkboxInputRow = "v_sG";
export var checkboxInputColumn = "v_sH";
export var inputOptionRow = "v_sy";
export var inputOptionColumn = "v_sz";